/** Label contracts — spec §6.11, §7.7b, F10. */
import { z } from 'zod';
import { hexColourSchema } from './common.js';
export const createLabelSchema = z
    .object({
    name: z.string().trim().min(1).max(40),
    colour: hexColourSchema.default('#7C838A'),
    description: z.string().max(200).optional(),
})
    .strict();
export const updateLabelSchema = createLabelSchema.partial().strict();
//# sourceMappingURL=label.js.map